import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { GuidedHouseholdReviewSections } from 'Components/UI/guidedHouseholdReview/sections';
import { FDPrimaryActionButton, FDSecondaryActionButton, FDStack } from '@facet-wealth/design';
import { makeLinkOpenInFocusMode } from 'Helpers/Navigation';
import { useLayoutContext } from 'Context/LayoutContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { householdEditRecordExpenseUri, householdEditRecordIncomeDetailsUri } from 'Consts/advisorUris';
import { dataAttrs } from 'Helpers/Testing';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';
import { metaOverrideSet } from './metaOverrideSet';

export const GuidedHouseholdReviewFutureIncomeAndExpensesLayout = () => {
  const { resource, saving, onSubmit } = useMetaLayoutContext();
  const { isFocusedLayout } = useLayoutContext();

  const { householdId } = useSimpleHousehold();
  const incomeEditLink = householdEditRecordIncomeDetailsUri(householdId);
  const expenseEditLink = householdEditRecordExpenseUri(householdId);

  const overwriteWithFocusMode = isFocusedLayout
    ? makeLinkOpenInFocusMode
    : (input) => input; // Since we're not in focused layout, we don't have any overwriting to do

  return (
    <>
      <GuidedHouseholdReviewSections metaOverrideSet={metaOverrideSet} collection={resource.attr('incomeSections')} shownAsDateTable />
      <GuidedHouseholdReviewSections metaOverrideSet={metaOverrideSet} collection={resource.attr('expensesSections')} shownAsDateTable />
      <FDStack direction="row" justifyContent="center" spacing={2} paddingY={2}>
        <WizardBackButtonRel size="lg" resource={resource} />
        <FDPrimaryActionButton
          {...dataAttrs('submit-btn')}
          loading={saving}
          onClick={onSubmit}
          label={resource.attr('primaryActionLabel') || 'Submit'}
          icon={'arrowRight'}
          iconPosition={'end'}
          size="lg"
        />
      </FDStack>
      <FDStack direction="row" justifyContent="center" spacing={2}>
        <FDSecondaryActionButton size="lg" href={overwriteWithFocusMode(incomeEditLink)} openInNewTab label={resource.attr('incomeEditLabel')} />
        <FDSecondaryActionButton size="lg" href={overwriteWithFocusMode(expenseEditLink)} openInNewTab label={resource.attr('expensesEditLabel')} />
      </FDStack>
    </>
  );
};
